import React, { useCallback, useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { Select } from '../../Shared/Select'
import CardItem from "../../Shared/CardItem"
import { useWindowSize } from "../../../hooks/useWindowSize"
import { useCustomWallet } from "../../../contexts/WalletContext"
import { SwitchGrid } from "../../Shared/SwitchGrid"
import {
  MainContentContainer,
  CardList,
  ContentHeader,
  HeaderActionList,
  SelectWrapper,
  Option,
  SwitchWrapper
} from "./styles";

const PIXELS_TO_SCROLL = 100;

export const MainContent = (props) => {
  const {
    isOpenRightMenu,
    isMoreView,
    isLoading,
    nftList,
    paginationProps,
    getNftList,
    isLoadMore,
    setIsMoreView,
    setSortSelected,
    sortSelected,
    method
  } = props;

  const windowSize = useWindowSize();
  let navigate = useNavigate();

  const itemsRef = useRef(null);
  const { getWalletAddressBySessionKey } = useCustomWallet()
  const [updateNftList, setUpdateNftList] = useState([])

  const sortList = [
    { id: 0, value: 'recently_listed', content: <Option>Recently listed</Option>},
    { id: 1, value: 'recently_sold', content: <Option>Recently sold</Option>},
    { id: 2, value: 'recently_created', content: <Option>Recently created</Option>},
    { id: 3, value: 'most_favorite', content: <Option>Most favorite</Option>},
    { id: 4, value: 'most_viewed', content: <Option>Most viewed</Option>},
    { id: 5, value: 'ending_soon', content: <Option>Ending soon</Option>},
    { id: 6, value: 'low_high_price', content: <Option>Low to high price</Option>},
    { id: 7, value: 'high_low_price', content: <Option>High to low price</Option>},
    { id: 8, value: 'highest_last_sale', content: <Option>Highest last sale</Option>}
  ]

  const handleChangeSort = (val) => {
    setSortSelected(val)
  }

  const handleDetails = (nft) => {
    if (nft?.method === 0) navigate(`/products/${nft.collectionAddress}/${nft.tokenId}/${nft.saleId}/buy`)
    else if (nft?.method === 1) navigate(`/products/${nft.collectionAddress}/${nft.tokenId}/${nft.saleId}/bid`)
    else {
      if (getWalletAddressBySessionKey() === nft.owner.toLowerCase()) {
        navigate(`/products/${nft.collectionAddress}/${nft.tokenId}/sale`);
      } else {
        navigate(`/products/${nft.collectionAddress}/${nft.tokenId}/${nft.owner}/offer`);
      }      
    }
  };

  const handleScroll = useCallback(() => {
    if (isLoadMore) return;

    const innerHeightScrolltop =
      itemsRef?.current.offsetHeight +
      itemsRef?.current.scrollTop +
      PIXELS_TO_SCROLL;
      if (itemsRef?.current.scrollHeight < innerHeightScrolltop && paginationProps.current_page <= paginationProps.total_pages) {
        getNftList(paginationProps.current_page + 1, paginationProps.page_size)
      }
  }, [isLoadMore, paginationProps, getNftList])

  useEffect(() => {
    itemsRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      itemsRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll])

  useEffect(() => {
    let _updateNftList = []
    if ((method === 0 || method === 1) && sortSelected === 'recently_listed') {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.when) - new Date(b.when))
    } else if (method === 2 && sortSelected === 'recently_sold') {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.lastSoldTime) - new Date(b.lastSoldTime))
    } else if (sortSelected === 'recently_created' && method === 2) {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.when) - new Date(b.when))
    } else if (sortSelected === 'most_favorite') {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.favoriteCount) > new Date(b.favoriteCount) ? 1 : -1)
    } else if ((method === 0 || method === 1) && sortSelected === 'highest_last_sale') {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.price) > new Date(b.price) ? 1 : -1)
    } else if ((method === 0 || method === 1) && sortSelected === 'high_low_price') {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.price) > new Date(b.price) ? 1 : -1)
    } else if ((method === 0 || method === 1) && sortSelected === 'low_high_price') {
      _updateNftList = [].concat(nftList).sort((a, b) => new Date(a.price) > new Date(b.price) ? -1 : 1)
    } else {
      _updateNftList = [...nftList]
    }
    setUpdateNftList(_updateNftList)

  }, [sortSelected, nftList, method])

  return (
    <MainContentContainer
      ref={itemsRef}
      style={
        windowSize.width < 800 && isOpenRightMenu
          ? { display: "none" }
          : { display: "block" }
      }
    >
      <ContentHeader>
        <HeaderActionList>
          <SelectWrapper>
            <Select
              notReload
              placeholder='Select token'
              options={sortList}
              defaultValue={sortSelected}
              onChange={val => handleChangeSort(val)}
            />
          </SelectWrapper>
          <SwitchWrapper>
            <SwitchGrid
              isMoreView={isMoreView}
              setIsMoreView={setIsMoreView}
            />
          </SwitchWrapper>
        </HeaderActionList>
      </ContentHeader>
      <CardList isMoreView={isMoreView}>
        {!isLoading && updateNftList?.length > 0 && updateNftList.map((item, i) => (
          <CardItem
            key={i}
            item={item}
            onClick={() => handleDetails(item)}
          />
        ))}
        {isLoadMore && [...Array(15).keys()].map((i) => (
          <CardItem key={i} isSkeleton />
        ))}
      </CardList>
      {!isLoading && updateNftList.length === 0 && <div className="no-result">No Result!</div>}
    </MainContentContainer>
  );
};
